import Image from 'next/image'
import Link from 'next/link'

export default function FooterSection() {
  return (
    <>
      {/* Final Image Section */}
      <section className='mx-auto py-10 md:py-20 md:pr-16'>
        <div className='grid grid-cols-1 items-center md:h-full md:grid-cols-2'>
          <Image
            src='https://mcdn.coolmate.me/image/March2025/mceclip3_136.jpg'
            alt='Final Image'
            width={1000}
            height={1000}
            className='w-full'
          />
          <Image
            src='https://mcdn.coolmate.me/image/March2025/mceclip4_13.png'
            alt='Final Image'
            width={1000}
            height={1000}
            className='w-full'
          />
        </div>
      </section>
      {/* Footer CTA */}
      <section className='mx-auto mb-10 px-4 md:mb-14 md:px-16'>
        <div
          className='flex flex-col items-center justify-between rounded-xl bg-neutral-800 bg-cover bg-right bg-no-repeat px-5 py-4 md:flex-row md:px-20 md:py-8'
          style={{
            backgroundImage:
              "url('https://media.coolmate.me/image/March2025/mceclip3_92.png')",
            backgroundSize: '100px',
          }}
        >
          <div className='text-heading-7 md:text-heading-6 text-white'>
            Bộ quy tắc ứng xử và đạo đức Coolmate
          </div>
          <Link
            href='https://mcdn.coolmate.me/uploads/coc/coolmate_code_of_business.pdf'
            target='_blank'
            className='rounded-full bg-white px-6 py-2 text-center text-sm uppercase text-black max-md:mt-3 max-md:w-full md:px-12 md:py-3 md:text-base'
          >
            Tìm hiểu thêm
          </Link>
        </div>
      </section>

      {/* Final Image */}
      <div className='w-full'>
        <picture className='w-full'>
          <source
            srcSet='https://mcdn.coolmate.me/image/March2025/mceclip0_121.jpg'
            media='(max-width: 768px)'
          />
          <Image
            src='https://mcdn.coolmate.me/image/March2025/mceclip2_131.jpg'
            alt='Vision 2030 Footer'
            width={1920}
            height={1080}
            className='w-full'
          />
        </picture>
      </div>
    </>
  )
}
